/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{getDefaultUnitForView as t}from"../support/getDefaultUnitForView.js";const e={readOnly:!0,get(){return t(this.view)}};export{e as defaultUnitPropertyMetadata};
